import { render, staticRenderFns } from "./BatteryLevels.vue?vue&type=template&id=bb2d9a72&"
import script from "./BatteryLevels.vue?vue&type=script&lang=js&"
export * from "./BatteryLevels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports